import * as React from 'react';
import { useSelector } from 'react-redux';

import { NEWBUILDING_PROMO_URL } from '../../../constants/newbuildingEntry';
import { getJsonQuery } from '../../../selectors/getJsonQuery';
import { getNewbuildingEntryAdPath } from '../../../selectors/newbuildingEntryBanner';
import { TNewbuildingEntryBannerType } from '../../../types/newbuildingEntryBanner';
import { useApplicationContext } from '../../../utils/applicationContext';
import { getNewbuildingEntryBannerInfo } from '../../../utils/getNewbuildingEntryBannerInfo';
import { NewbuildingEntryBanner } from '../../components/NewbuildingEntryBanner';
import { trackNewbuildingEntryBannerClick, trackNewbuildingEntryBannerShow } from './tracking';

interface INewbuildingEntryBannerContainerProps {
  type: TNewbuildingEntryBannerType;
}

export function NewbuildingEntryBannerContainer({ type }: INewbuildingEntryBannerContainerProps) {
  const newbuildingEntryAdPath = useSelector(getNewbuildingEntryAdPath);
  const jsonQuery = useSelector(getJsonQuery);

  const { logger, config } = useApplicationContext();
  const { title, description, url } = getNewbuildingEntryBannerInfo(type, config, logger);

  if (type === 'mixed_promo') {
    return (
      <NewbuildingEntryBanner
        onShow={() => trackNewbuildingEntryBannerShow('subsidized_mortgage', jsonQuery)}
        onClick={() => trackNewbuildingEntryBannerClick('subsidized_mortgage', jsonQuery)}
        url={url || NEWBUILDING_PROMO_URL}
        title={title}
        description={description}
        type={type}
      />
    );
  }

  return (
    <NewbuildingEntryBanner
      onShow={() => trackNewbuildingEntryBannerShow('mixed', jsonQuery)}
      onClick={() => trackNewbuildingEntryBannerClick('mixed', jsonQuery)}
      url={newbuildingEntryAdPath}
      title={title}
      description={description}
      type={type}
    />
  );
}
